export default "__VITE_ASSET__BErtHfQY__"